import { redirect } from '@tanstack/react-router'
import getBaseRoutePathByRole from '#app/lib/get-base-route-path-by-role'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'

export default function shouldBePostRegistered() {
  const roleInfo = getCurrentUserRoleInfo()

  if (roleInfo.role === 'unknown') {
    return
  }

  if (!roleInfo.isGiven) {
    throw redirect({ to: getBaseRoutePathByRole(roleInfo.role) })
  }
}
